import { Config } from "../model/Config.js";
import { VOClimate } from "../model/DataStructure.js";
import { Language } from "../model/Language.js";

export class Climate {
    public element: HTMLDivElement;
    private _idx: number;
    private _panel: HTMLDivElement[];
    private _iframe: HTMLIFrameElement;
    private _myClimateUrlDe: string;
    private _myClimateUrlEn: string;
    private _logo: HTMLDivElement;
    private _showKeyboard: boolean = false;

    constructor(climate: VOClimate) {
        if (!climate) {
            console.warn("Climate could not be instantiated. Missing climate parameter.");
            return;
        }

        this._panel = [];

        this.element = document.createElement("div");
        this.element.id = "climate";
        this.element.classList.add("scale-to-fit", "green-bg");
        this.element.setAttribute("data-panel", "home");
        document.body.appendChild(this.element);

        //logo
        this._logo = document.createElement("div");
        this._logo.id = "climate-lufthansa-logo";
        this.element.appendChild(this._logo);

        //home
        var home = document.createElement("div");
        home.id = "climate-home";
        this.element.appendChild(home);
        this._panel.push(home);

        var homeTitleDe = document.createElement("div");
        homeTitleDe.id = "climate-home-title-de";
        homeTitleDe.innerHTML = climate.title_de;
        home.appendChild(homeTitleDe);

        var homeTitleEn = document.createElement("div");
        homeTitleEn.id = "climate-home-title-en";
        homeTitleEn.innerHTML = climate.title_en;
        home.appendChild(homeTitleEn);

        var homeLanguageDe = document.createElement("div");
        homeLanguageDe.id = "climate-home-language-de";
        homeLanguageDe.setAttribute("data-lang", "de");
        // homeLanguageDe.innerHTML = "Deutsch";
        Language.label(homeLanguageDe, "climate.language-de", "", "Deutsch");
        homeLanguageDe.classList.add("btn");
        homeLanguageDe.classList.toggle("selected", Language.current == "de");
        homeLanguageDe.addEventListener("pointerdown", (e) => {
            e.stopImmediatePropagation();
            Language.current = "de";
            this.nextPanel();
        }, true);
        home.appendChild(homeLanguageDe);

        var homeLanguageEn = document.createElement("div");
        homeLanguageEn.id = "climate-home-language-en";
        homeLanguageEn.setAttribute("data-lang", "en");
        Language.label(homeLanguageEn, "climate.language-en", "", "English");
        homeLanguageEn.classList.add("btn");
        homeLanguageEn.classList.toggle("selected", Language.current == "en");
        homeLanguageEn.addEventListener("pointerdown", (e) => {
            e.stopImmediatePropagation();
            Language.current = "en";
            this.nextPanel();
        });
        home.appendChild(homeLanguageEn);

        //panel 1
        var panel1 = document.createElement("div");
        panel1.id = "climate-panel1";
        this.element.appendChild(panel1);
        this._panel.push(panel1);

        var panel1Text = document.createElement("div");
        panel1Text.id = "climate-panel1-text";
        Language.apply(panel1Text, climate.intro_de, climate.intro_en)
        panel1.appendChild(panel1Text);

        var panel1Next = document.createElement("div");
        panel1Next.id = "climate-panel1-next";

        var panel1NextLabel = document.createElement("span");

        Language.label(panel1NextLabel, "climate.panel1-next", "", "weiter");
        panel1Next.appendChild(panel1NextLabel);

        var panel1NextIcon = document.createElement("span");
        panel1NextIcon.classList.add("icon-62", "icon");
        panel1Next.appendChild(panel1NextIcon);

        panel1Next.addEventListener("pointerdown", (e) => {
            e.stopImmediatePropagation();
            this.nextPanel();
        });
        panel1.appendChild(panel1Next);

        //panel 2
        var panel2 = document.createElement("div");
        panel2.id = "climate-panel2";
        this.element.appendChild(panel2);
        this._panel.push(panel2);

        var panel2Image = document.createElement("img");
        panel2Image.id = "climate-panel2-image";
        panel2Image.src = climate.canvas_panel2_de.url;
        Language.apply(panel2Image, climate.canvas_panel2_de.url, climate.canvas_panel2_en.url, 'src');
        panel2.appendChild(panel2Image);

        var panel2Next = document.createElement("div");
        panel2Next.id = "climate-panel2-next";
        Language.label(panel2Next, "climate.panel2-next", "", "Errechnen Sie Ihren eigenen CO2 -Fußabdruck!");
        panel2Next.addEventListener("pointerdown", (e) => {
            e.stopImmediatePropagation();
            this.nextPanel();
        }, true);
        panel2.appendChild(panel2Next);

        //calculator
        this._myClimateUrlDe = "https://co2ide.myclimate.org/de/footprint_calculators/new?ps=" + Config.myclimatePartnerString;
        this._myClimateUrlEn = "https://co2ide.myclimate.org/en/footprint_calculators/new?ps=" + Config.myclimatePartnerString;

        var calculator = document.createElement("div");
        calculator.id = "climate-calculator";
        calculator.style.backgroundImage = "url(" + climate.canvas_calculator.url + ")";
        this.element.appendChild(calculator);
        this._panel.push(calculator);

        this._iframe = document.createElement("iframe");
        this._iframe.id = "climate-iframe";
        this._iframe.frameBorder = "0";
        this._iframe.src = this._myClimateUrlDe;
        Language.apply(this._iframe, this._myClimateUrlDe, this._myClimateUrlEn, 'src');
        this._iframe.setAttribute("allowtransparency", "");
        calculator.appendChild(this._iframe);

        if (window.api) {
            window.api.keyboard.setTheme("green");
            window.api.keyboard.setLayout({
                bottom: "50px",
                left: "50%",
                originX: "50%",
                originY: "0"
            });
            // window.api.keyboard.show();iuz

            window.api.lastInputInfo.maxIdleTime = Config.maxIdleTimeClimate * 1000;
            window.api.lastInputInfo.addEventLisener("idle", () => {
                this.reset();
            });
        }

        this._iframe.addEventListener("load", (e) => {
            if (window.ScriptInjection)
                new window.ScriptInjection(this._iframe.contentWindow);

            if (window.api) {
                var href = this._iframe.contentWindow.location.href;
                console.log("AAAHHH", href);
                console.log(href.indexOf(this._myClimateUrlDe) === -1 && href.indexOf(this._myClimateUrlEn) === -1);
                if (href.indexOf(this._myClimateUrlDe) === -1 && href.indexOf(this._myClimateUrlEn) === -1){
                    this.showKeyboard = true;
                }

                //Add some custom CSS
                try {
                    var css = `
                       #cookie-consent-dialog {
                            display: none !important;
                       }
                    `;
                    var style = document.createElement('style');
                    style.type = "text/css";
                    style.appendChild(document.createTextNode(css));
                    this._iframe.contentDocument.head.appendChild(style);
                } catch (e) { }
            }

            // console.log(ifr.src, ifr.srcdoc);
            // ifr.contentDocument.body.style.backgroundColor = "#FF00FF";
            // var win = ifr.contentDocument;
            // win.getElementById("col_middle").style.backgroundColor = "#FF00FF";
            // win.querySelector("#new_footprint_calculator > button").style.display = "none";
            // console.log("IFRAME LOADED....")
        });

        var calculatorReset = document.createElement("div");
        calculatorReset.id = "climate-calculator-reset";
        Language.label(calculatorReset, "climate.calculator-reset", "", "Neustart");
        calculatorReset.addEventListener("pointerdown", (e) => {
            e.stopImmediatePropagation();
            this.reset();
        }, true);
        calculator.appendChild(calculatorReset);

        this._idx = -1;
        this.nextPanel();
    }

    private reset(): void {
        if (window.api)
            window.api.clearCache();
        this._idx = -1;
        this.nextPanel();
    }


    private nextPanel(): void {
        this._idx++;
        if (this._idx == 0)
            this.resetIFrameUrl();

        if (this._idx == this._panel.length - 1) {
            // this.showKeyboard = true;
            this._logo.classList.add('hidden');
        } else {
            this.showKeyboard = false;
            this._logo.classList.remove('hidden');
        }
        for (var i = 0; i < this._panel.length; i++) {
            if (i == this._idx)
                this._panel[i].classList.remove('hidden');
            else
                this._panel[i].classList.add('hidden');

        }
    }

    protected get showKeyboard(): boolean {
        return this._showKeyboard;
    }

    protected set showKeyboard(showKeyboard: boolean) {
        if (!window.api?.keyboard)
            return;
        if (this._showKeyboard === showKeyboard) {
            return;
        }
        this._showKeyboard = showKeyboard;
        if (showKeyboard) {
            console.log("SHOW KEYBOARD");
            window.api.keyboard.show();
        }
        else {
            window.api.keyboard.hide();
        }
    }

    private resetIFrameUrl(): void {
        if (Language.current == Language.GERMAN)
            this._iframe.src = this._myClimateUrlDe;
        else
            this._iframe.src = this._myClimateUrlEn;
    }
}